(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[717],{

/***/ 543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _CustomError_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8883);
/* harmony import */ var _CustomError_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_CustomError_module_css__WEBPACK_IMPORTED_MODULE_3__);




const CustomError = (param)=>{
    let { statusCode , title  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: statusCode ? "".concat(statusCode, ": ").concat(typeof title === "string" ? title : "Error") : "Error"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_CustomError_module_css__WEBPACK_IMPORTED_MODULE_3___default().customError),
                children: [
                    statusCode && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: statusCode
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: title
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomError);


/***/ }),

/***/ 2578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3992);
/* harmony import */ var _LikeCards_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1798);
/* harmony import */ var _LikeCards_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LikeCards_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);






const LikeCards = (param)=>{
    let { title , subtitle , subSubTitle , image , to , href , type ="small"  } = param;
    let width, height;
    switch(type){
        case "big":
            width = "AUTO";
            height = 900;
            break;
        case "aspect-ratio":
            width = "AUTO";
            height = 200;
            break;
        default:
        case "small":
            width = 600;
            height = "AUTO";
            break;
    }
    const Card = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mb-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_LikeCards_module_css__WEBPACK_IMPORTED_MODULE_4___default()["like-cards"]), "like-cards", (_LikeCards_module_css__WEBPACK_IMPORTED_MODULE_4___default())[type], "d-flex", "justify-content-center", "align-items-center"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (0,_services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_5__/* .imageResizer */ .J)(image, width, height),
                        alt: title
                    })
                }),
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    className: "text-black mb-0 font-secondary fw-700 fs-16px elipsis-2-lines",
                    children: title
                }),
                subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mb-0 font-primary text-black fs-14px font-primary",
                    children: subtitle
                }),
                subSubTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mb-0 color-gray-super-light fs-13px font-primary fs-13px",
                    children: subSubTitle
                })
            ]
        });
    if (to && href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: href,
            as: to,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {})
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (LikeCards);


/***/ }),

/***/ 6089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pages_ArtworkDetailPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./services/utils/linksBuilder.js
var linksBuilder = __webpack_require__(3372);
// EXTERNAL MODULE: ./services/utils/slugify.js
var slugify = __webpack_require__(3384);
// EXTERNAL MODULE: ./services/nodeApiService.js + 1 modules
var nodeApiService = __webpack_require__(9885);
;// CONCATENATED MODULE: ./features/actions/useArtworkDetailsActions.js



const useArtworkDetailsActions = (artwork, insertArplacerButtons)=>{
    const recaptchaRef = (0,react.useRef)();
    const [form, setForm] = (0,react.useState)({
        email: "",
        firstname: "",
        lastname: "",
        body: ""
    });
    const [modal, setModal] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)(false);
    const [errorMessage, setErrorMessage] = (0,react.useState)([]);
    const [success, setSuccess] = (0,react.useState)(false);
    const handleClose = ()=>{
        setModal(false);
        setTimeout(()=>{
            setSuccess(false);
        }, 500);
    };
    const handleShow = ()=>{
        setSuccess(false);
        setModal(true);
    };
    const onSubmit = (event)=>{
        event.preventDefault();
        recaptchaRef.current.execute();
    };
    const successCallback = ()=>{
        setSuccess(true);
        setForm({
            email: "",
            firstname: "",
            lastname: "",
            body: ""
        });
    };
    const onReCAPTCHAChange = async (captchaCode)=>{
        if (!captchaCode) {
            return;
        }
        setError(false);
        nodeApiService/* default.inquire */.Z.inquire(artwork.id, {
            ...form,
            captcha: captchaCode,
            channel: "discover",
            type: "artwork_inquiry_discover"
        }).then((_)=>{
            successCallback();
        }, (res)=>{
            setError(true);
            setErrorMessage(res.response.data.errorMessage);
        });
        recaptchaRef.current.reset();
    };
    // insertArplacerButtons must be memoized by the caller: an inline function
    // would re-insert the widget buttons on every render.
    // Deferred so rapid changes collapse into one insert and the widget's own
    // pending (setTimeout 0) insert lands before our clear, avoiding duplicates.
    (0,react.useEffect)(()=>{
        if (!insertArplacerButtons) return;
        const timer = setTimeout(insertArplacerButtons, 0);
        return ()=>clearTimeout(timer);
    }, [
        insertArplacerButtons
    ]);
    return {
        form,
        setForm,
        modal,
        handleClose,
        handleShow,
        onSubmit,
        error,
        errorMessage,
        success,
        onReCAPTCHAChange,
        recaptchaRef
    };
};

;// CONCATENATED MODULE: ./features/actions/useArtworkPurchaseActions.js



const useArtworkPurchaseActions = (artwork)=>{
    const recaptchaRefPurchase = (0,react.useRef)();
    const [formPurchase, setFormPurchase] = (0,react.useState)({
        email: "",
        firstname: "",
        lastname: "",
        phone: "",
        shipping: {
            street: "",
            city: "",
            state: "",
            country: "",
            zip: ""
        },
        body: ""
    });
    const [modalPurchase, setModalPurchase] = (0,react.useState)(false);
    const [errorPurchase, setErrorPurchase] = (0,react.useState)(false);
    const [errorMessagePurchase, setErrorMessagePurchase] = (0,react.useState)([]);
    const [successPurchase, setSuccessPurchase] = (0,react.useState)(false);
    const handleClosePurchase = ()=>{
        setModalPurchase(false);
        setTimeout(()=>{
            setSuccessPurchase(false);
        }, 500);
    };
    const handleShowPurchase = ()=>{
        setSuccessPurchase(false);
        setModalPurchase(true);
    };
    const onSubmitPurchase = (event)=>{
        event.preventDefault();
        recaptchaRefPurchase.current.execute();
    };
    const successCallback = ()=>{
        setSuccessPurchase(true);
        setFormPurchase({
            email: "",
            firstname: "",
            lastname: "",
            phone: "",
            shipping: {
                street: "",
                city: "",
                state: "",
                country: "",
                zip: ""
            },
            body: ""
        });
    };
    const onReCAPTCHAChangePurchase = async (captchaCode)=>{
        if (!captchaCode) {
            return;
        }
        setErrorPurchase(false);
        nodeApiService/* default.purchase */.Z.purchase(artwork.id, {
            ...formPurchase,
            captcha: captchaCode,
            channel: "discover",
            type: "purchase_discover"
        }).then((_)=>{
            successCallback();
        }, (res)=>{
            setErrorPurchase(true);
            setErrorMessagePurchase(res.response.data.errorMessage);
        });
        recaptchaRefPurchase.current.reset();
    };
    return {
        formPurchase,
        setFormPurchase,
        modalPurchase,
        handleClosePurchase,
        handleShowPurchase,
        onSubmitPurchase,
        errorPurchase,
        errorMessagePurchase,
        successPurchase,
        onReCAPTCHAChangePurchase,
        recaptchaRefPurchase
    };
};

// EXTERNAL MODULE: ./features/actions/useContactAction.js
var useContactAction = __webpack_require__(5419);
// EXTERNAL MODULE: ./features/components/Layout/HelmetTitle/index.js
var HelmetTitle = __webpack_require__(6470);
// EXTERNAL MODULE: ./features/pages/ArtworkDetailPage/ArtworkDetailPage.module.css
var ArtworkDetailPage_module = __webpack_require__(3211);
var ArtworkDetailPage_module_default = /*#__PURE__*/__webpack_require__.n(ArtworkDetailPage_module);
// EXTERNAL MODULE: ./features/components/Layout/Button/index.js
var Button = __webpack_require__(158);
// EXTERNAL MODULE: ./features/components/Layout/Container/index.js
var Container = __webpack_require__(1286);
// EXTERNAL MODULE: ./features/components/LikeCards/index.js
var LikeCards = __webpack_require__(2578);
// EXTERNAL MODULE: ./features/components/Layout/Wrapper/index.js
var Wrapper = __webpack_require__(1350);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 13 modules
var Form = __webpack_require__(4835);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 46 modules
var Modal = __webpack_require__(6986);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(4853);
// EXTERNAL MODULE: ./services/utils/imageResizer.js
var imageResizer = __webpack_require__(3992);
;// CONCATENATED MODULE: ./features/pages/ArtworkDetailPage/ArtworkModal.js










const ArtworkModal = (param)=>{
    let { artworkSize , modal , handleClose , onSubmit , artworkDetails , setForm , form , error , errorMessage , success , onReCAPTCHAChange , recaptchaRef  } = param;
    const innerRef = /*#__PURE__*/ react.createRef();
    react.useEffect(()=>{
        setTimeout(()=>{
            var _innerRef_current;
            (_innerRef_current = innerRef.current) === null || _innerRef_current === void 0 ? void 0 : _innerRef_current.focus();
        }, 1);
    }, [
        modal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: modal,
        onHide: handleClose,
        className: (ArtworkDetailPage_module_default())["modal-content"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                className: (ArtworkDetailPage_module_default()).modal,
                closeButton: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                className: (ArtworkDetailPage_module_default())["modal-body"],
                closeButton: true,
                children: success ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-4 px-2 mb-4 w-100 text-center alert",
                        children: [
                            "Your inquiry has been sent. We'll get back to you soon.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Thank you!"
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-4 px-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-black mb-3 fs-24px",
                                children: "Inquire"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            className: "mb-3 mx-4 px-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 5,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((ArtworkDetailPage_module_default()).BigPostal, (ArtworkDetailPage_module_default())["image-modal"]),
                                        style: {
                                            backgroundSize: "contain",
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                            backgroundImage: "url(".concat((0,imageResizer/* imageResizer */.J)(artworkDetails.image, "AUTO", 200), ")")
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 7,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "mb-0 text-black font-weight-bold fs-16px",
                                            children: artworkDetails.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "text-black font-weight-normal mb-2 font-primary fs-14px",
                                            children: artworkDetails.artistname
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "text-black font-weight-normal mb-0 font-primary fs-14px",
                                            children: artworkDetails.gallery.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            className: "color-gray-super-light font-weight-normal font-primary fs-13px",
                                            children: artworkSize
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                                className: "mx-4 px-2",
                                onSubmit: onSubmit,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        controlId: "exampleForm.ControlInput1",
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "text-capitalize text-black fs-14px",
                                                children: "Email*"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                className: "input-font-size",
                                                type: "email",
                                                autoFocus: true,
                                                ref: innerRef,
                                                onChange: (event)=>{
                                                    setForm({
                                                        ...form,
                                                        email: event.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                as: Col/* default */.Z,
                                                controlId: "exampleForm.ControlInput1",
                                                className: "mb-2 pr-2 pl-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                        className: "text-capitalize text-black fs-14px",
                                                        children: "First Name*"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                        className: "input-font-size",
                                                        type: "name",
                                                        onChange: (event)=>{
                                                            setForm({
                                                                ...form,
                                                                firstname: event.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                as: Col/* default */.Z,
                                                controlId: "exampleForm.ControlInput1",
                                                className: "mb-2 pl-2 pr-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                        className: "text-capitalize text-black fs-14px",
                                                        children: "Last Name*"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                        className: "input-font-size",
                                                        type: "name",
                                                        onChange: (event)=>{
                                                            setForm({
                                                                ...form,
                                                                lastname: event.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        controlId: "exampleForm.ControlTextarea1",
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "text-capitalize text-black fs-14px",
                                                children: "Message*"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                className: "input-font-size",
                                                as: "textarea",
                                                rows: "5",
                                                onChange: (event)=>{
                                                    setForm({
                                                        ...form,
                                                        body: event.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                        ref: recaptchaRef,
                                        size: "invisible",
                                        sitekey: "6LeDv1IaAAAAABVo8NAoSR50zN8nU1OgpZFBzyOO",
                                        onChange: onReCAPTCHAChange
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-100 alert alert-danger",
                                        children: errorMessage.map((error)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    error,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                ]
                                            }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ArtworkDetailPage_module_default()).enquireButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            name: "SUBMIT",
                                            type: "submit"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/pages/ArtworkDetailPage/ArtworkPurchaseModal.js










const ArtworkPurchaseModal = (param)=>{
    let { artworkSize , modal , handleClose , onSubmit , artworkDetails , setForm , form , error , errorMessage , success , onReCAPTCHAChange , recaptchaRef  } = param;
    const innerRef = /*#__PURE__*/ react.createRef();
    react.useEffect(()=>{
        setTimeout(()=>{
            var _innerRef_current;
            (_innerRef_current = innerRef.current) === null || _innerRef_current === void 0 ? void 0 : _innerRef_current.focus();
        }, 1);
    }, [
        modal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: modal,
        onHide: handleClose,
        className: (ArtworkDetailPage_module_default())["modal-content"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                className: (ArtworkDetailPage_module_default()).modal,
                closeButton: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                className: (ArtworkDetailPage_module_default())["modal-body"],
                closeButton: true,
                children: success ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-4 px-2 mb-4 w-100 text-center alert",
                        children: [
                            "Your purchase request has been sent. We'll get back to you soon.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Thank you!"
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-4 px-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-black mb-3 fs-24px",
                                children: "Purchase"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            className: "mb-3 mx-4 px-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 5,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((ArtworkDetailPage_module_default()).BigPostal, (ArtworkDetailPage_module_default())["image-modal"]),
                                        style: {
                                            backgroundSize: "contain",
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                            backgroundImage: "url(".concat((0,imageResizer/* imageResizer */.J)(artworkDetails.image, "AUTO", 200), ")")
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 7,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "mb-0 text-black font-weight-bold fs-16px",
                                            children: artworkDetails.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "text-black font-weight-normal mb-2 font-primary fs-14px",
                                            children: artworkDetails.artistname
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "text-black font-weight-normal mb-0 font-primary fs-14px",
                                            children: artworkDetails.gallery.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            className: "color-gray-super-light font-weight-normal font-primary fs-13px",
                                            children: artworkSize
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                                className: "mx-4 px-2",
                                onSubmit: onSubmit,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        controlId: "exampleForm.ControlInput1",
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "text-capitalize text-black fs-12px",
                                                children: "Email*"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                className: "input-font-size",
                                                type: "email",
                                                autoFocus: true,
                                                ref: innerRef,
                                                onChange: (event)=>{
                                                    setForm({
                                                        ...form,
                                                        email: event.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                as: Col/* default */.Z,
                                                controlId: "exampleForm.ControlInput1",
                                                className: "mb-1 pr-2 pl-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                        className: "text-capitalize text-black fs-12px",
                                                        children: "First Name*"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                        className: "input-font-size",
                                                        type: "name",
                                                        onChange: (event)=>{
                                                            setForm({
                                                                ...form,
                                                                firstname: event.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                as: Col/* default */.Z,
                                                controlId: "exampleForm.ControlInput1",
                                                className: "mb-1 pl-2 pr-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                        className: "text-capitalize text-black fs-12px",
                                                        children: "Last Name*"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                        className: "input-font-size",
                                                        type: "name",
                                                        onChange: (event)=>{
                                                            setForm({
                                                                ...form,
                                                                lastname: event.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        controlId: "exampleForm.ControlInput1",
                                        className: "mb-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "text-capitalize text-black fs-12px",
                                                children: "Phone"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                className: "input-font-size",
                                                type: "phone",
                                                onChange: (event)=>{
                                                    setForm({
                                                        ...form,
                                                        phone: event.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                            as: Col/* default */.Z,
                                            controlId: "formGroupShipping1",
                                            className: "mb-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                    className: "text-capitalize text-black fs-12px",
                                                    children: "Shipping info*"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    className: "input-font-size",
                                                    type: "text",
                                                    placeholder: "Street",
                                                    onChange: (event)=>{
                                                        setForm({
                                                            ...form,
                                                            shipping: {
                                                                ...form.shipping,
                                                                street: event.target.value
                                                            }
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                                                as: Col/* default */.Z,
                                                controlId: "formGroupShipping2",
                                                className: "mb-1 pr-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    className: "input-font-size",
                                                    type: "text",
                                                    placeholder: "City",
                                                    onChange: (event)=>{
                                                        setForm({
                                                            ...form,
                                                            shipping: {
                                                                ...form.shipping,
                                                                city: event.target.value
                                                            }
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                                                as: Col/* default */.Z,
                                                controlId: "formGroupShipping3",
                                                className: "mb-1 pr-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    className: "input-font-size",
                                                    type: "text",
                                                    placeholder: "State",
                                                    onChange: (event)=>{
                                                        setForm({
                                                            ...form,
                                                            shipping: {
                                                                ...form.shipping,
                                                                state: event.target.value
                                                            }
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                                                as: Col/* default */.Z,
                                                controlId: "formGroupShipping3",
                                                className: "mb-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                    className: "input-font-size",
                                                    type: "text",
                                                    placeholder: "Zip",
                                                    onChange: (event)=>{
                                                        setForm({
                                                            ...form,
                                                            shipping: {
                                                                ...form.shipping,
                                                                zip: event.target.value
                                                            }
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                                            as: Col/* default */.Z,
                                            controlId: "formGroupShipping4",
                                            className: "mb-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                className: "input-font-size",
                                                type: "text",
                                                placeholder: "Country",
                                                onChange: (event)=>{
                                                    setForm({
                                                        ...form,
                                                        shipping: {
                                                            ...form.shipping,
                                                            country: event.target.value
                                                        }
                                                    });
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        controlId: "exampleForm.ControlTextarea1",
                                        className: "mb-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                className: "text-capitalize text-black fs-12px",
                                                children: "Message"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                className: "input-font-size",
                                                as: "textarea",
                                                rows: "3",
                                                onChange: (event)=>{
                                                    setForm({
                                                        ...form,
                                                        body: event.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                        ref: recaptchaRef,
                                        size: "invisible",
                                        sitekey: "6LeDv1IaAAAAABVo8NAoSR50zN8nU1OgpZFBzyOO",
                                        onChange: onReCAPTCHAChange
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-100 alert alert-danger",
                                        children: errorMessage.map((error)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    error,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                ]
                                            }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ArtworkDetailPage_module_default()).enquireButton,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            name: "SUBMIT",
                                            type: "submit"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./features/components/Layout/SeoTags/index.js
var SeoTags = __webpack_require__(7182);
;// CONCATENATED MODULE: ./services/utils/getFileExtension.js
const getFileExtension = (file)=>{
    if (!file) {
        return null;
    }
    const re = /(?:\.([^.]+))?$/;
    return re.exec(file)[1];
};

// EXTERNAL MODULE: ./services/utils/getArtworkSize.js
var getArtworkSize = __webpack_require__(731);
// EXTERNAL MODULE: ./services/utils/getArtworkTitle.js
var getArtworkTitle = __webpack_require__(194);
// EXTERNAL MODULE: ./services/utils/getArtworkSubtitle.js
var getArtworkSubtitle = __webpack_require__(9296);
// EXTERNAL MODULE: ./services/utils/isKnownArtist.js
var isKnownArtist = __webpack_require__(5157);
;// CONCATENATED MODULE: ./services/utils/addPossessive.js
const addPossessive = (word)=>{
    if (word.endsWith("s")) {
        return word + "'";
    } else {
        return word + "'s";
    }
};

// EXTERNAL MODULE: ./features/providers/AppProvider.js
var AppProvider = __webpack_require__(2674);
// EXTERNAL MODULE: ./features/components/GalleryContactModal/index.js
var GalleryContactModal = __webpack_require__(7538);
// EXTERNAL MODULE: ./services/utils/formatPrice.js
var formatPrice = __webpack_require__(1479);
;// CONCATENATED MODULE: ./services/utils/formatArtworkSize.js
const SIZE_UNITS = {
    IN: "in",
    CM: "cm"
};
const CM_PER_INCH = 2.54;
// Rounding is presentation-only: every call converts from the stored inches.
const formatters = {
    [SIZE_UNITS.IN]: (inches)=>"".concat(inches.toFixed(2), '"'),
    [SIZE_UNITS.CM]: (inches)=>"".concat(parseFloat((inches * CM_PER_INCH).toFixed(1)), " cm")
};
const formatArtworkSize = function(width, height) {
    let unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : SIZE_UNITS.IN;
    const format = formatters[unit] || formatters[SIZE_UNITS.IN];
    const h = parseFloat(height) ? "".concat(format(parseFloat(height)), " H") : "";
    const w = parseFloat(width) ? "".concat(format(parseFloat(width)), " W") : "";
    return [
        h,
        w
    ].filter(Boolean).join(" x ");
};

// EXTERNAL MODULE: ./features/components/UnitSwitch/UnitSwitch.module.scss
var UnitSwitch_module = __webpack_require__(4936);
var UnitSwitch_module_default = /*#__PURE__*/__webpack_require__.n(UnitSwitch_module);
;// CONCATENATED MODULE: ./features/components/UnitSwitch/index.js





const UnitSwitch = (param)=>/*#__PURE__*/ {
    let { value , onChange  } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: (UnitSwitch_module_default())["switch"],
        role: "group",
        "aria-label": "Size unit",
        children: Object.values(SIZE_UNITS).map((unit)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                "aria-pressed": value === unit,
                className: classnames_default()((UnitSwitch_module_default()).option, {
                    [(UnitSwitch_module_default()).active]: value === unit
                }),
                onClick: ()=>onChange(unit),
                children: unit
            }, unit))
    });
};
/* harmony default export */ var components_UnitSwitch = (UnitSwitch);

;// CONCATENATED MODULE: ./features/pages/ArtworkDetailPage/index.js






























const ArtworkDetailPage = (param)=>{
    let { artworkDetails , relatedArtworks , gallery  } = param;
    const { profile  } = (0,AppProvider/* useAppContext */.b)();
    // Props-derived so SSR HTML (meta description, Size column) carries the real
    // value; a state-based size would be null until hydration.
    const artworkSize = (0,getArtworkSize/* getArtworkSize */.Y)(artworkDetails.width, artworkDetails.height);
    const [sizeUnit, setSizeUnit] = (0,react.useState)(SIZE_UNITS.IN);
    const displayedSize = formatArtworkSize(artworkDetails.width, artworkDetails.height, sizeUnit);
    // The widget reads its params once per insert, so this re-runs (via the
    // effect in useArtworkDetailsActions, keyed on this callback's identity, hence
    // the useCallback) whenever the artwork or unit changes.
    const insertArplacerButtons = (0,react.useCallback)(()=>{
        if (typeof ArtPlacer === "undefined") {
            console.warn("ArtPlacer widget script not loaded; skipping buttons");
            return;
        }
        ArtPlacer.clear();
        ArtPlacer.insert({
            gallery: artworkDetails.gallery.id,
            type: "1",
            text: "Try in Your Room",
            artwork: artworkDetails.id,
            // Dedicated selector: .artplacerSize is shared styling across four spans
            // (Size/Date/Medium/Material), so first-match would read the Date when
            // the Size column doesn't render. Null when there's nothing to read.
            size: artworkSize ? ".artplacerSizeValue" : null,
            unit: sizeUnit,
            price: null,
            classname: "btn btn-secondary-light tt-u fw-700 fs-12px mb-2 mr-2 ".concat((ArtworkDetailPage_module_default())["view-button"]),
            after: ".artplacerButtons"
        });
        gallery.featured_space && ArtPlacer.insert({
            gallery: artworkDetails.gallery.id,
            type: "2",
            text: "View in sample room",
            artwork: artworkDetails.id,
            space: gallery.featured_space.id,
            unit: sizeUnit,
            classname: "btn btn-secondary-light tt-u fw-700 fs-12px mb-2 mr-2 ".concat((ArtworkDetailPage_module_default())["view-button"]),
            after: ".artplacerButtons"
        });
        getFileExtension(artworkDetails.image) != "gif" && ArtPlacer.insert({
            gallery: artworkDetails.gallery.id,
            type: "3",
            artwork: artworkDetails.id,
            unit: sizeUnit,
            classname: "btn btn-secondary-light tt-u fw-700 fs-12px mb-2 mr-2 ".concat((ArtworkDetailPage_module_default())["view-button"]),
            after: ".artplacerButtons"
        });
    }, [
        artworkDetails,
        gallery,
        artworkSize,
        sizeUnit
    ]);
    const { form , setForm , onSubmit , handleShow , handleClose , modal , error , errorMessage , success , onReCAPTCHAChange , recaptchaRef  } = useArtworkDetailsActions(artworkDetails, insertArplacerButtons);
    const { formPurchase , setFormPurchase , onSubmitPurchase , handleShowPurchase , handleClosePurchase , modalPurchase , errorPurchase , errorMessagePurchase , successPurchase , onReCAPTCHAChangePurchase , recaptchaRefPurchase  } = useArtworkPurchaseActions(artworkDetails);
    const { form: formContact , setForm: setFormContact , onSubmit: onSubmitContact , handleShow: handleShowContact , handleClose: handleCloseContact , modal: modalContact , success: successContact , error: errorContact , errorMessage: errorMessageContact , onReCAPTCHAChange: onReCAPTCHAChangeContact , recaptchaRef: recaptchaRefContact , loading: loadingContact  } = (0,useContactAction/* useContactAction */.J)(gallery);
    const showMaterialOrMediumRow = artworkDetails.medium || artworkDetails.material;
    const BreadCrumbs = (param)=>{
        let { resposiveStyle ="d-flex"  } = param;
        if (!profile.embedded || !gallery) return;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-muted fs-13px mt-3 ".concat(resposiveStyle),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                    href: "/galleries/".concat(gallery.id, "/artworks"),
                    to: "/galleries/".concat(gallery.id, "/artworks"),
                    className: "text-decoration-underline",
                    children: [
                        addPossessive(gallery.name),
                        " artworks"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "mx-1",
                    children: "/"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: artworkDetails.title
                })
            ]
        });
    };
    const artworkPageURL = "https://discover.artplacer.com/galleries/".concat(artworkDetails.gallery.domain, "/artworks/").concat(artworkDetails.id, "-").concat((0,slugify/* slugify */.l)(artworkDetails.title));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* SeoTags */.o, {
                    title: "".concat(artworkDetails.title, " | Discover ArtPlacer"),
                    description: "Check out ".concat(artworkDetails.title, " from ").concat(artworkDetails.gallery.name, ". Try it in your room or make an inquiry. ").concat(artworkSize ? "Real size: ".concat(artworkSize, ". ") : "").concat(artworkDetails.description || ""),
                    image: (0,imageResizer/* imageResizer */.J)(artworkDetails.image, 340, "AUTO"),
                    url: artworkPageURL,
                    canonical: artworkPageURL
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelmetTitle/* HelmetTitle */.i, {
                    title: artworkDetails.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "".concat(profile.embedded ? "my-3" : "mb-5"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs, {
                            resposiveStyle: "d-block d-md-none pt-0 pb-4 px-5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: 7,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ArtworkDetailPage_module_default()).BigPostal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,imageResizer/* imageResizer */.J)(artworkDetails.image, "AUTO", 800),
                                    alt: artworkDetails.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            md: 5,
                            className: "px-5 d-flex flex-column justify-content-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs, {
                                    resposiveStyle: "d-none d-md-block py-sm-5 pt-md-0 py-md-4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "fs-32px fw-300 mb-3",
                                    children: (0,getArtworkTitle/* getArtworkTitle */.H)(artworkDetails.title)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "mb-0 mb-md-4",
                                    children: [
                                        (0,isKnownArtist/* isKnownArtist */.b)(artworkDetails.artistname) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            md: 4,
                                            className: "mb-2 mb-md-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "color-black mb-0 fs-14px",
                                                    children: "Artist"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "color-black mb-4 mb-md-0 font-primary fs-14px",
                                                    children: artworkDetails.artistname
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            md: 5,
                                            className: "mb-2 mb-md-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "color-black mb-0 fs-14px",
                                                    children: "Gallery"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/galleries/[id]",
                                                    as: linksBuilder/* linksBuilder.galleries */.m.galleries(artworkDetails.gallery.domain),
                                                    className: "color-black td-u mb-4 mb-md-0 font-primary fs-14px",
                                                    children: artworkDetails.gallery.name
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (artworkSize || artworkDetails.date) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "mb-0 mb-md-4",
                                    children: [
                                        artworkSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            md: 6,
                                            className: "mb-2 mb-md-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex align-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                            className: "color-black mb-0 fs-14px",
                                                            children: "Size"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UnitSwitch, {
                                                            value: sizeUnit,
                                                            onChange: setSizeUnit
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "color-gray-super-light font-primary fs-14px artplacerSize artplacerSizeValue",
                                                    "aria-live": "polite",
                                                    children: displayedSize
                                                })
                                            ]
                                        }),
                                        artworkDetails.date && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            md: 5,
                                            className: "mb-2 mb-md-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "color-black mb-0 fs-14px",
                                                    children: "Date"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "color-gray-super-light font-primary fs-14px artplacerSize",
                                                    children: artworkDetails.date
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                showMaterialOrMediumRow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "mb-0 mb-md-4",
                                    children: [
                                        artworkDetails.medium && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            md: 4,
                                            className: "mb-2 mb-md-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "color-black mb-0 fs-14px",
                                                    children: "Medium"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "color-gray-super-light font-primary fs-14px artplacerSize",
                                                    children: artworkDetails.medium
                                                })
                                            ]
                                        }),
                                        artworkDetails.material && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            md: 5,
                                            className: "mb-2 mb-md-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "color-black mb-0 fs-14px",
                                                    children: "Material"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "color-gray-super-light font-primary fs-14px artplacerSize",
                                                    children: artworkDetails.material
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                artworkDetails.description && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2 mb-md-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                            className: "color-black mb-0 fs-14px",
                                            children: "Description"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "color-gray-super-light font-primary fs-14px",
                                            style: {
                                                whiteSpace: "pre-wrap"
                                            },
                                            children: artworkDetails.description
                                        })
                                    ]
                                }),
                                artworkDetails.price && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: "mb-0 mb-md-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        md: 12,
                                        className: "mb-2 mb-md-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                className: "color-black mb-0 fs-14px",
                                                children: "Price"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "color-gray-super-light font-primary fs-14px",
                                                children: artworkDetails.sold ? "Sold" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        artworkDetails.gallery.currency.symbol,
                                                        " ",
                                                        (0,formatPrice/* formatPrice */.T)(artworkDetails.price)
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "m-0 mt-4 mt-md-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            md: 6,
                                            sm: 12,
                                            className: "mx-0 mb-2 pl-0 pr-md-1 px-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                name: "INQUIRE",
                                                onClick: handleShow,
                                                variant: "outline-dark"
                                            })
                                        }),
                                        !profile.embedded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            md: 6,
                                            sm: 12,
                                            className: "mx-0 mb-2 pr-0 pl-md-1 px-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                name: "PURCHASE",
                                                onClick: handleShowPurchase
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: "color-black fs-14px mb-3",
                                        children: "Try it!"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "artplacerButtons"
                                        })
                                    })
                                }),
                                artworkDetails.about_artist && (0,isKnownArtist/* isKnownArtist */.b)(artworkDetails.artistname) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                            className: "color-black mb-0 fs-14px",
                                            children: [
                                                "About ",
                                                artworkDetails.artistname
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "color-gray-super-light font-primary fs-14px",
                                            children: artworkDetails.about_artist
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-black mb-2 fs-24px",
                            children: "You may also like"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: relatedArtworks && relatedArtworks.map((artwork)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 6,
                                    md: 4,
                                    lg: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LikeCards/* default */.Z, {
                                        title: (0,getArtworkTitle/* getArtworkTitle */.H)(artwork.title),
                                        subtitle: (0,getArtworkSubtitle/* getArtworkSubtitle */.z)(artwork.artistname, gallery === null || gallery === void 0 ? void 0 : gallery.name),
                                        subSubTitle: (0,getArtworkSize/* getArtworkSize */.Y)(artwork.width, artwork.height),
                                        image: artwork.image,
                                        to: linksBuilder/* linksBuilder.artworks */.m.artworks(gallery === null || gallery === void 0 ? void 0 : gallery.domain, artwork.id, artwork.title),
                                        href: "/galleries/[id]/artworks/[artwork]",
                                        type: "aspect-ratio"
                                    })
                                }, "like-cards-".concat(artwork.id));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtworkModal, {
                    form: form,
                    setForm: setForm,
                    artworkDetails: artworkDetails,
                    artworkSize: displayedSize,
                    modal: modal,
                    onSubmit: onSubmit,
                    handleClose: handleClose,
                    error: error,
                    errorMessage: errorMessage,
                    success: success,
                    recaptchaRef: recaptchaRef,
                    onReCAPTCHAChange: onReCAPTCHAChange
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtworkPurchaseModal, {
                    form: formPurchase,
                    setForm: setFormPurchase,
                    artworkDetails: artworkDetails,
                    artworkSize: displayedSize,
                    modal: modalPurchase,
                    onSubmit: onSubmitPurchase,
                    handleClose: handleClosePurchase,
                    error: errorPurchase,
                    errorMessage: errorMessagePurchase,
                    success: successPurchase,
                    recaptchaRef: recaptchaRefPurchase,
                    onReCAPTCHAChange: onReCAPTCHAChangePurchase
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryContactModal/* GalleryContactModal */.X, {
                    form: formContact,
                    setForm: setFormContact,
                    galleryDetails: gallery,
                    modal: modalContact,
                    onSubmit: onSubmitContact,
                    handleClose: handleCloseContact,
                    error: errorContact,
                    errorMessage: errorMessageContact,
                    success: successContact,
                    recaptchaRef: recaptchaRefContact,
                    onReCAPTCHAChange: onReCAPTCHAChangeContact
                })
            ]
        })
    });
};
/* harmony default export */ var pages_ArtworkDetailPage = (ArtworkDetailPage);


/***/ }),

/***/ 8591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1555);
/* harmony import */ var _components_Layout_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1286);
/* harmony import */ var _components_Layout_Wrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1350);
/* harmony import */ var _ArtworksErrorPage_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4337);
/* harmony import */ var _ArtworksErrorPage_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_ArtworksErrorPage_module_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_LikeCards__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2578);
/* harmony import */ var _services_utils_getArtworkSize__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(731);
/* harmony import */ var _services_utils_linksBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3372);
/* harmony import */ var _components_CustomError__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(543);










const ArtworksErrorPage = (param)=>{
    let { status , artwork , relatedArtworks , gallery  } = param;
    const getErrorMessage = (status)=>{
        switch(status){
            case 404:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: "The requested artwork is not available. Please check out these other artworks instead!"
                });
            case 403:
                var _artwork_title;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: (_artwork_title = artwork === null || artwork === void 0 ? void 0 : artwork.title) !== null && _artwork_title !== void 0 ? _artwork_title : artwork === null || artwork === void 0 ? void 0 : artwork.id
                        }),
                        " is no longer available, but you may be interested in these artworks:"
                    ]
                });
            case 500:
            default:
                return "Something went wrong. Please try again later.";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Wrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: "justify-content-center text-black fs-15px fs-mobile-14px ".concat(relatedArtworks ? (_ArtworksErrorPage_module_css__WEBPACK_IMPORTED_MODULE_8___default().artworksErrorPageExtended) : (_ArtworksErrorPage_module_css__WEBPACK_IMPORTED_MODULE_8___default().artworksErrorPage)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CustomError__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        title: getErrorMessage(status)
                    })
                }),
                relatedArtworks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: relatedArtworks.map((artwork)=>{
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                xs: 6,
                                md: 4,
                                lg: 2,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LikeCards__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    title: artwork.title,
                                    subtitle: artwork.artistname,
                                    subSubTitle: (0,_services_utils_getArtworkSize__WEBPACK_IMPORTED_MODULE_10__/* .getArtworkSize */ .Y)(artwork.width, artwork.height),
                                    image: artwork.image,
                                    to: _services_utils_linksBuilder__WEBPACK_IMPORTED_MODULE_5__/* .linksBuilder.artworks */ .m.artworks(gallery === null || gallery === void 0 ? void 0 : gallery.domain, artwork.id, artwork.title),
                                    href: "/galleries/[id]/artworks/[artwork]",
                                    type: "aspect-ratio"
                                })
                            }, "like-cards-".concat(artwork.id));
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArtworksErrorPage);


/***/ }),

/***/ 1479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ formatPrice; }
/* harmony export */ });
const formatPrice = (price)=>{
    if (isNaN(price)) return price;
    let roundedPrice = Math.round(price * 100) / 100;
    let [integerPart, decimalPart] = roundedPrice.toString().split(".");
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (decimalPart && decimalPart !== "00") {
        return "".concat(integerPart, ".").concat(decimalPart);
    }
    return "".concat(integerPart);
};


/***/ }),

/***/ 9296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getArtworkSubtitle; }
/* harmony export */ });
/* harmony import */ var _isKnownArtist__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5157);

const getArtworkSubtitle = (artistname, galleryName)=>{
    if (!(0,_isKnownArtist__WEBPACK_IMPORTED_MODULE_0__/* .isKnownArtist */ .b)(artistname)) return galleryName !== null && galleryName !== void 0 ? galleryName : null;
    return artistname;
};


/***/ }),

/***/ 5157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ isKnownArtist; }
/* harmony export */ });
const isKnownArtist = (artistname)=>Boolean(artistname) && artistname !== "Unknown Artist";


/***/ }),

/***/ 8883:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customError":"CustomError_customError__o6Ond"};

/***/ }),

/***/ 1798:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"like-cards":"LikeCards_like-cards__HIXtb","big":"LikeCards_big__CRvCF","aspect-ratio":"LikeCards_aspect-ratio__xNe3Q"};

/***/ }),

/***/ 3211:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"enquireButton":"ArtworkDetailPage_enquireButton__nZmIC","btn-dark":"ArtworkDetailPage_btn-dark__66mEN","BigPostal":"ArtworkDetailPage_BigPostal__7rDTi","image-modal":"ArtworkDetailPage_image-modal__W1hGF","modal":"ArtworkDetailPage_modal__mtzwU","modal-body":"ArtworkDetailPage_modal-body__2D1Mv","submit":"ArtworkDetailPage_submit__T0QOU","view-button":"ArtworkDetailPage_view-button__6rLo4"};

/***/ }),

/***/ 4337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"artworksErrorPage":"ArtworksErrorPage_artworksErrorPage__w5oSp","artworksErrorPageExtended":"ArtworksErrorPage_artworksErrorPageExtended__T_CKc"};

/***/ }),

/***/ 4936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"switch":"UnitSwitch_switch__9RfLe","option":"UnitSwitch_option__KAIgD","active":"UnitSwitch_active__C_IPi"};

/***/ })

}]);